let searchCounter = {};
let availableStores = {};

import Vue from 'vue';

import {EMPTY, LOADING, READY, ERROR} from 'module/constants';
import common from 'module/common';
import store from 'module/store';
import filters from "module/filters";

export const getSearchStore = function (storeName) {
  return _.get(availableStores, storeName, null);
};

export default class {
  constructor(name) {
    searchCounter[name] = searchCounter[name] ? searchCounter[name] + 1 : 1;

    this.name = name;
    this.storeName = `search-${name}-${searchCounter[name]}`;

    availableStores[this.storeName] = this;

    //set action names
    this.init = `${this.storeName}/init`;
    this.view = `${this.storeName}/view`;
    this.paused = `${this.storeName}/paused`;
    this.updateFrom = `${this.storeName}/updateFrom`;
    this.reset = `${this.storeName}/reset`;
    this.search = `${this.storeName}/search`;
    this.clearSearch = `${this.storeName}/clearSearch`;
    this.updateRow = `${this.storeName}/updateRow`;
    this.removeRow = `${this.storeName}/removeRow`;
    this.disableFilters = `${this.storeName}/disableFilters`;
    this.disableUserConfig = `${this.storeName}/disableUserConfig`;
    this.myTasks = `${this.storeName}/myTasks`;
    this.columns = `${this.storeName}/columns`;
    this.sort = `${this.storeName}/sort`;
    this.resetSort = `${this.storeName}/resetSort`;
    this.fetch = `${this.storeName}/fetch`;
    this.fetchFilter = `${this.storeName}/fetchFilter`;
    this.loadMore = `${this.storeName}/loadMore`;
    this.loading = `${this.storeName}/loading`;

    this.setFilter = `${this.storeName}/setFilter`;
    this.filter = `${this.storeName}/filter`;

    this.clearFilters = `${this.storeName}/clearFilters`;
    this.resetFilters = `${this.storeName}/resetFilters`;

    store.registerModule(this.storeName, this.getModule());
  }

  remove() {
    store.unregisterModule(this.storeName);
  }

  getModule() {
    let searchStore = this;

    const STATE = `${this.storeName}_STATE`;
    const VIEW = `${this.storeName}_VIEW`;
    const MY_TASKS = `${this.storeName}_MY_TASKS`;
    const LOADED_ALL = `${this.storeName}_LOADED_ALL`;
    const SEARCH = `${this.storeName}_SEARCH`;
    const FROM = `${this.storeName}_FROM`;
    const LAST_PAGINATION_VALUE = `${this.storeName}_LAST_PAGINATION_VALUE`;
    const DISABLE_FILTERS = `${this.storeName}_DISABLE_FILTERS`;
    const DISABLE_USER_CONFIG = `${this.storeName}_DISABLE_USER_CONFIG`;
    const FETCH_ID = `${this.storeName}_FETCH_ID`;
    const TOTAL = `${this.storeName}_TOTAL`;
    const ROWS = `${this.storeName}_ROWS`;
    const ACTIONS = `${this.storeName}_ACTIONS`;
    const COLUMNS = `${this.storeName}_COLUMNS`;
    const SORT = `${this.storeName}_SORT`;
    const FILTERS_AVAILABLE = `${this.storeName}_FILTERS_AVAILABLE`;
    const FILTERS_OPTIONS = `${this.storeName}_FILTERS_OPTIONS`;
    const FILTERS_SELECTED = `${this.storeName}_FILTERS_SELECTED`;
    const INIT_STATE = `${this.storeName}_INIT_STATE`;
    const FETCH_STARTED = `${this.storeName}_FETCH_STARTED`;
    const VIEW_CHANGED = `${this.storeName}_VIEW_CHANGED`;
    const FIRST_PAGE_RECEIVED = `${this.storeName}_FIRST_PAGE_RECEIVED`;
    const ROWS_PAGE_RECEIVED = `${this.storeName}_ROWS_PAGE_RECEIVED`;

    let searchTimeout = null;
    let resetTimeout = null;
    let viewChangeId = 0;

    const runAfterLoadingPaint = (callback) => {
      if (typeof window === 'undefined') {
        setTimeout(callback, 0);
        return;
      }

      const requestFrame = window.requestAnimationFrame || ((next) => setTimeout(next, 0));
      requestFrame(() => setTimeout(callback, 0));
    };

    const buildRowStoreId = (row, index) => {
      if (row && row._searchStoreRowId) {
        return row._searchStoreRowId;
      }

      if (row && row._id) {
        return `${searchStore.storeName}-${filters.formatOID(row._id)}-${index}`;
      }

      if (row && row.ref) {
        return `${searchStore.storeName}-${row.ref}-${index}`;
      }

      return `${searchStore.storeName}-${index}`;
    };

    const getFilterOptionCounts = (filters = []) => {
      return filters.map((filter) => ({
        name: filter.name,
        options: Array.isArray(filter.options) ? filter.options.length : 0
      }));
    };

    const freezeOptions = (options = []) => {
      return Object.freeze(Array.isArray(options) ? options.slice() : []);
    };

    const freezeList = (items = []) => {
      return Object.freeze(Array.isArray(items) ? items.slice() : []);
    };

    const freezeObject = (object = {}) => {
      return Object.freeze(Object.assign({}, object));
    };

    const freezeColumns = (columns = {}, defaultColumns = []) => {
      return Object.freeze({
        show: freezeList(columns.show),
        available: freezeList(columns.available),
        default: freezeList(columns.default || defaultColumns)
      });
    };

    const freezeSort = (sort = {}) => {
      return Object.freeze({
        keyPath: sort.keyPath,
        direction: sort.direction
      });
    };

    const freezeView = (view = {}) => {
      return Object.freeze({
        type: view.type,
        subType: view.subType,
        name: view.name,
        options: freezeObject(view.options || {})
      });
    };

    const freezeFiltersAvailable = (filtersAvailable = []) => {
      return filtersAvailable.map((filter) => {
        return Object.assign({}, filter, {
          options: freezeOptions(filter.options)
        });
      });
    };

    const freezeRows = (rows = []) => {
      return freezeList(rows);
    };

    const queueReset = (dispatch) => {
      if (resetTimeout !== null) {
        clearTimeout(resetTimeout);
      }


      resetTimeout = setTimeout(() => {
        resetTimeout = null;
        dispatch('reset');
      }, 0);
    };

    // initial state
    const state = {
      initialised: false,
      state: EMPTY,
      view: {
        type: null,
        subType: null,
        name: null,
        options: {}
      },
      exportUrl: 'file.php?a=portal/search',
      myTasks: false,
      loadedAll: false,
      search: null,
      from: 0,
      lastPaginationValue: null,
      disableFilters: false,
      disableUserConfig: false,
      fetchId: null,
      actions: [],
      columns: {
        show: [],
        available: [],
        default: [],
      },
      sort: {
        keyPath: null,
        direction: -1
      },
      rows: [],
      total: {
        overall: 0,
        filterSelection: 0
      },
      filters: {
        available: [],
        selected: {}
      }
    };

    //actions
    const actions = {
      loading({commit}) {
        commit(STATE, LOADING);
      },
      init({commit, dispatch}, {view, disableFilters, disableUserConfig, myTasks, search, from}) {
        let fetchId = common.createGuid();

        commit(INIT_STATE, {
          view,
          disableFilters,
          disableUserConfig,
          myTasks,
          search,
          from,
          fetchId
        });

        dispatch('fetch', {
          fetchId,
          started: true
        });
      },
      view({commit, dispatch, state}, {view, override}) {

        if (_.isEqual(view, state.view)) {
          return;
        }

        const nextViewId = ++viewChangeId;
        const existingView = state.view;

        if (override !== true) {
          view = _.merge({}, existingView, view);
        }

        commit(STATE, LOADING);

        runAfterLoadingPaint(() => {
          if (nextViewId !== viewChangeId) {
            return;
          }

          commit(VIEW_CHANGED, {view});
          dispatch('fetch');
        });
      },
      search({commit, dispatch}, search) {
        if (searchTimeout !== null) {
          clearTimeout(searchTimeout);
        }

        searchTimeout = setTimeout(() => {
          searchTimeout = null;
          commit(SEARCH, search);
          dispatch('reset');
        }, 350);
      },
      clearSearch({commit, dispatch, state}, fetch) {
        if (state.search === null) {
          return;
        }

        commit(SEARCH, null);

        if (fetch === true) {
          dispatch('reset');
        }
      },
      updateRow({commit, state}, {rowId, rowToUpdate}) {
        rowToUpdate._searchStore = searchStore.storeName;
        rowToUpdate._searchStoreRowId = rowId;

        let rows = state.rows.map((row) =>
          (filters.formatOID(row._id) === filters.formatOID(rowToUpdate._id) &&
            filters.formatOID(row._searchStoreRowId) === filters.formatOID(rowId))
            ? rowToUpdate
            : row
        );

        commit(ROWS, rows);
      },
      removeRow({commit, state}, rowToRemove) {
        commit(ROWS, state.rows.filter((row) => row._id !== rowToRemove._id));
      },
      setFilter({commit, dispatch, state}, {name, value, fetch}) {

        if (fetch === undefined) {
          fetch = true;
        }

        let selected = _.cloneDeep(state.filters.selected);

        let selectedForFilter = selected[name] || [];
        let indexOfValue = selectedForFilter.indexOf(value);

        if (indexOfValue <= -1) {
          selectedForFilter.push(value);
          selected[name] = selectedForFilter;
        } else {
          selectedForFilter.splice(indexOfValue, 1);

          if (selectedForFilter.length >= 1) {
            selected[name] = selectedForFilter;
          } else {
            delete selected[name];
          }
        }

        commit(FILTERS_SELECTED, selected);

        if (fetch === true) {
          queueReset(dispatch);
        }
      },
      clearFilters({commit, dispatch, state}, fetch) {
        if (_.isEmpty(state.filters.selected)) {
          return;
        }

        commit(FILTERS_SELECTED, {});

        if (fetch === true) {
          queueReset(dispatch);
        }
      },
      resetFilters({commit, dispatch}, {filters, fetch}) {
        commit(FILTERS_SELECTED, filters);
        if (fetch === true) {
          queueReset(dispatch);
        }
      },
      reset({commit, dispatch}) {
        commit(FROM, 0);
        commit(LAST_PAGINATION_VALUE, null);
        commit(LOADED_ALL, false);
        dispatch('fetch');
      },
      updateFrom({commit, dispatch}, {from, fetch}) {
        commit(FROM, from);

        if (fetch === true) {
          dispatch('fetch');
        }
      },
      disableFilters({commit, dispatch}, disableFilters) {
        commit(DISABLE_FILTERS, disableFilters === true);
        dispatch('reset');
      },
      disableUserConfig({commit, dispatch}, disableUserConfig) {
        commit(DISABLE_USER_CONFIG, disableUserConfig === true);
        dispatch('reset');
      },
      myTasks({commit, dispatch}, myTasks) {
        commit(MY_TASKS, myTasks === true);
        dispatch('reset');
      },
      columns({commit, dispatch}, columns) {
        commit(COLUMNS, columns);
        dispatch('reset');
      },
      sort({commit, dispatch}, sort) {
        commit(SORT, sort);
        dispatch('reset');
      },
      resetSort({commit, dispatch}, reset) {
        commit(SORT, {
          keyPath: null,
          direction: -1
        });

        if (reset !== false) {
          dispatch('reset');
        }
      },
      fetch({commit, dispatch, state, rootGetters}, options = {}) {
        let idToken = rootGetters['user/idToken']();
        let view = state.view;
        let disableFilters = state.disableFilters;
        let disableUserConfig = state.disableUserConfig;
        let myTasks = state.myTasks;
        let columns = state.columns.show.map(({name, order}) => ({name, order, show: true}));
        let sort = state.sort;
        let search = state.search && state.search.length >= 3 ? state.search : null;
        let from = state.from;
        let lastPaginationValue = state.lastPaginationValue;
        let filterValues = state.filters.selected;

        filterValues = _.isEmpty(filterValues) === false ? filterValues : null;

        let fetchId = options.fetchId || common.createGuid();

        if (options.started !== true) {
          commit(FETCH_STARTED, fetchId);
        }

        if (from === 0) {
          //Fetch initial info for search excluding the filters
          common
            .httpPost('search')
            .set('x-search-store', searchStore.storeName)
            .data({
              action: 'searchWithoutFilters',
              idToken,
              view,
              myTasks,
              columns,
              sort,
              search,
              lastPaginationValue,
              filterValues,
              disableUserConfig
            })
            .then((res) => {
              if (fetchId !== state.fetchId) {
                //another request has overridden this one
                return;
              }

              let rows = res.data.rows.map((row, index) => {
                row._searchStore = searchStore.storeName;
                row._searchStoreRowId = buildRowStoreId(row, index);
                return row;
              });

              commit(FIRST_PAGE_RECEIVED, {
                data: {
                  actions: freezeList(res.data.actions),
                  columns: res.data.columns,
                  filters: freezeFiltersAvailable(res.data.filters),
                  from: res.data.from,
                  lastPaginationValue: res.data.lastPaginationValue,
                  sort: freezeSort(res.data.sort),
                  total: freezeObject(res.data.total)
                },
                rows: freezeRows(rows),
                disableFilters
              });
            }, (error) => {
              commit(STATE, ERROR);
              dispatch('error/error', error, {root: true});
            });
        } else {
          //Fetch the rows only
          common
            .httpPost('search')
            .set('x-search-store', searchStore.storeName)
            .data({
              action: 'searchRowsOnly',
              idToken,
              view,
              myTasks,
              sort,
              search,
              from,
              lastPaginationValue,
              filterValues,
              disableUserConfig
            })
            .then((res) => {
              if (fetchId !== state.fetchId) {
                //another request has overridden this one
                return;
              }

              let rows = res.data.rows.map((row, index) => {
                row._searchStore = searchStore.storeName;
                row._searchStoreRowId = buildRowStoreId(row, state.rows.length + index);
                return row;
              });

              commit(ROWS_PAGE_RECEIVED, {
                data: {
                  from: res.data.from,
                  lastPaginationValue: res.data.lastPaginationValue,
                  rows: res.data.rows
                },
                rows: freezeRows(state.rows.concat(rows))
              });
            }, (error) => {
              commit(STATE, ERROR);
              dispatch('error/error', error, {root: true});
            });
        }
      },
      fetchFilter({commit, dispatch, state, rootGetters}, filterNames) {
        let idToken = rootGetters['user/idToken']();
        let view = state.view;
        let filterValues = state.filters.selected;

        common
          .httpPost('search')
          .set('x-search-store', searchStore.storeName)
          .data({
            action: 'searchSingleFilter',
            idToken,
            view,
            filterNames,
            filterValues,
          })
          .then((res) => {
            if (Object.keys(res.data.filters).length >= 1) {
              commit(FILTERS_OPTIONS, res.data.filters);
            }
          }, (error) => {
            commit(STATE, ERROR);
            dispatch('error/error', error, {root: true});
          });
      }
    };

    //getters
    const getters = {
      exportPostData: (state, getters, rootState, rootGetters) => (exportEntity) => {
        let idToken = rootGetters['user/idToken']();
        let action = exportEntity === 'project' ? 'requestExport' : 'search';
        let view = state.view;
        let myTasks = state.myTasks;
        let search = state.search && state.search.length >= 3 ? state.search : null;
        let filterValues = state.filters.selected;
        let exportType = 'EXCEL';
        let parametersForExport = {idToken, action, view, myTasks, search, filterValues, exportType};

        return exportEntity === 'project' ? parametersForExport : JSON.stringify(parametersForExport);
      },
      rows(state) {
        return state.rows ?? [];
      }
    };

    // mutations
    const mutations = {
      [INIT_STATE](state, {view, disableFilters, disableUserConfig, myTasks, search, from, fetchId}) {
        if (from !== undefined && from !== null) {
          state.from = from;
        }

        state.state = LOADING;
        state.fetchId = fetchId;
        state.disableFilters = disableFilters === true;
        state.disableUserConfig = disableUserConfig === true;
        state.myTasks = myTasks === true;
        state.search = search;
        state.view = freezeView(view);
      },
      [FETCH_STARTED](state, fetchId) {
        state.state = LOADING;
        state.fetchId = fetchId;
      },
      [VIEW_CHANGED](state, {view}) {
        state.columns = Object.freeze({
          show: [],
          available: [],
          default: state.columns.default
        });
        state.filters.available = freezeFiltersAvailable();
        state.view = freezeView(view);
        state.sort = Object.freeze({
          keyPath: null,
          direction: -1
        });
        state.from = 0;
        state.lastPaginationValue = null;
        state.loadedAll = false;
      },
      [FIRST_PAGE_RECEIVED](state, {data, rows, disableFilters}) {
        state.state = READY;
        state.loadedAll = rows.length < 25;
        state.total = data.total;
        state.actions = data.actions;
        state.columns = freezeColumns(data.columns, state.columns.default);
        state.sort = data.sort;
        state.rows = rows;
        state.from = data.from;
        state.lastPaginationValue = data.lastPaginationValue;

        if (disableFilters === false && state.filters.available.length <= 0 && Object.keys(data.filters).length >= 1) {
          state.filters.available = data.filters;
        }
      },
      [ROWS_PAGE_RECEIVED](state, {data, rows}) {
        state.state = READY;

        if (data.rows.length < 25) {
          state.loadedAll = true;
        }

        state.rows = rows;
        state.from = data.from;
        state.lastPaginationValue = data.lastPaginationValue;
      },
      [STATE](state, newState) {
        state.state = newState;
      },
      [VIEW](state, view) {
        state.view = freezeView(view);
      },
      [MY_TASKS](state, myTasks) {
        state.myTasks = myTasks === true;
      },
      [DISABLE_FILTERS](state, disableFilters) {
        state.disableFilters = disableFilters === true;
      },
      [DISABLE_USER_CONFIG](state, disableUserConfig) {
        state.disableUserConfig = disableUserConfig === true;
      },
      [LOADED_ALL](state, loadedAll) {
        state.loadedAll = loadedAll === true;
      },
      [SEARCH](state, search) {
        state.search = search;
      },
      [FROM](state, from) {
        state.from = from;
      },
      [LAST_PAGINATION_VALUE](state, lastPaginationValue) {
        state.lastPaginationValue = lastPaginationValue;
      },
      [FETCH_ID](state, fetchId) {
        state.fetchId = fetchId;
      },
      [TOTAL](state, total) {
        state.total = freezeObject(total);
      },
      [ROWS](state, rows) {
        state.rows = freezeRows(rows);
      },
      [ACTIONS](state, actions) {
        state.actions = freezeList(actions);
      },
      [COLUMNS](state, columns) {
        state.columns = freezeColumns(columns);
      },
      [SORT](state, sort) {
        state.sort = freezeSort(sort);
      },
      [FILTERS_AVAILABLE](state, filtersAvailable) {
        state.filters.available = freezeFiltersAvailable(filtersAvailable);
      },
      [FILTERS_OPTIONS](state, filters) {
        filters.forEach((filter) => {
          let existingIndex = state.filters.available.findIndex(currentFilter => currentFilter.name === filter.name);

          if (existingIndex >= 0) {
            Vue.set(state.filters.available[existingIndex], 'options', freezeOptions(filter.options));
          }
        });
      },
      [FILTERS_SELECTED](state, filtersSelected) {
        state.filters.selected = filtersSelected;
      }
    };

    return {
      namespaced: true,
      state,
      actions,
      getters,
      mutations
    };
  }
}
